import styled from 'styled-components';

export const RangeList = styled.div`
  margin-bottom: 1rem;
`;

export const RangeItem = styled.div`
  margin-top: 1.325rem;
`;
